module.exports = __webpack_public_path__ + "media/images/logo/BPR LOGO-5190c794eedb8343ed2823be93265db1.png";